export default __webpack_public_path__ + "static/media/user-journey-img5.93d4586d.svg";